import React, { Component } from 'react';
import './AliasesList.css';
import PropTypes from 'prop-types';
import { Table, Button } from 'reactstrap';
import _ from 'lodash';
import IconContainer from '../../../commonComponents/iconContainer/IconContainer';
import { sharedLabelsPath } from "../../../../reducers/common/localization";
import { ADD_MODE, EDIT_MODE } from '../addAliasModal/AddAliasModal';
import RemoveAliasModal from './../removeAliasModal/RemoveAliasModal.container';
import AddAliasModal from './../addAliasModal/AddAliasModal.container';

class AliasesList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: this.props.data,
            currentAliasId: null,
            mode: null
        };
    }

    componentDidMount() {
        this.props.onGetAliases();
    }

    render() {
        return (
            <div className='aliases-list-container'>
                <h5 className="text-center">{_.get(this.props.translation, 'aliases.label')}</h5>
                <div className="buttons-group">
                    <Button
                        className='add-alias-button olive-green-btn'
                        onClick={this.onAddButtonClick}
                    >
                        {_.get(this.props.translation, sharedLabelsPath.add_button)}
                    </Button>
                </div>
                {this.renderContent()}
                <RemoveAliasModal
                    id={this.state.currentAliasId}
                />
                <AddAliasModal
                    mode={this.state.mode}
                    id={this.state.currentAliasId}
                />
            </div>
        );
    }

    renderContent = () => {
        if (this.props.loading) {
            return (
                <div className="aliases-status-message-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            );
        }
        return (
            <Table className='aliases-list-table' cellSpacing="0">
                <thead>
                    <tr>
                        <th/>
                        <th>{_.get(this.props.translation, sharedLabelsPath.first_name_label)}</th>
                        <th>{_.get(this.props.translation, sharedLabelsPath.last_name_label)}</th>
                        <th>{_.get(this.props.translation, sharedLabelsPath.phone_number_label)}</th>
                        <th>{_.get(this.props.translation, sharedLabelsPath.country_label)}</th>
                        <th className="expose-header">{_.get(this.props.translation, 'aliases.expose_phone_label')}</th>
                        <th className="expose-header">{_.get(this.props.translation, 'aliases.expose_email_label')}</th>
                        <th/>
                        <th/>
                    </tr>
                </thead>
                <tbody>
                    {this.renderAliasesData()}
                </tbody>
            </Table>
        );
    };

    renderAliasesData() {
        let sortedData = _.orderBy(this.props.data, ['default'], ['desc']);
        return _.map(sortedData, (alias, index) => (
            <tr key={index} className={"aliases-list-row " + (alias.default ? "default-alias" : "")}>
                <td className="aliases-icon-container">
                    {
                        alias.default ?
                            <IconContainer
                                className="aliases-icon"
                                title={_.get(this.props.translation, 'aliases.default_alias_label')}
                                icon="radio_button_checked"
                                key={"default-alias-" + alias.id}
                            />
                            :
                            <IconContainer
                                className="aliases-icon"
                                title={_.get(this.props.translation, 'aliases.set_as_default_alias_label')}
                                icon="radio_button_unchecked"
                                key={"non-default-alias-" + alias.id}
                                onClick={this.changeDefaultAlias(alias.id)}
                            />
                    }
                </td>
                <td>{alias.firstName}</td>
                <td>{alias.lastName}</td>
                <td>{alias.phoneNumber}</td>
                <td>{_.get(this.props.translation, sharedLabelsPath.countries + '.' + alias.countryCode)}</td>
                <td className="aliases-icon-container">
                    <IconContainer
                        className="aliases-icon"
                        icon={"check_box" + (!alias.exposePhone ? "_outline_blank" : "")}
                        key={"expose-phone-" + alias.id}
                        onClick={this.onExposePhoneClick(alias.id, alias)}
                        title={_.get(this.props.translation, 'aliases.expose_phone_label')}
                    />
                </td>
                <td className="aliases-icon-container">
                    <IconContainer
                        className="aliases-icon"
                        icon={"check_box" + (!alias.exposeEmail ? "_outline_blank" : "")}
                        key={"expose-email-" + alias.id}
                        onClick={this.onExposeEmailClick(alias.id, alias)}
                        title={_.get(this.props.translation, 'aliases.expose_email_label')}
                    />
                </td>
                <td className="aliases-icon-container">
                    <IconContainer
                        className="aliases-icon"
                        icon="create"
                        key={"edit-alias-" + alias.id}
                        onClick={this.onEditButtonClick(alias.id)}
                        title={_.get(this.props.translation, 'aliases.edit_alias_label')}
                    />
                </td>
                <td className="aliases-icon-container">
                    {alias.default ? null :
                        <IconContainer
                            className="aliases-icon"
                            icon="clear"
                            key={"delete-alias-" + alias.id}
                            onClick={this.onRemoveButtonClick(alias.id)}
                            title={_.get(this.props.translation, 'aliases.delete_alias_label')}
                        />
                    }
                </td>
            </tr>
        ));
    }

    changeDefaultAlias = (id) => () => {
        this.props.onSetDefaultAlias(id);
    };

    onExposePhoneClick = (id, alias) => () => {
        let data = alias;
        data.exposePhone = !data.exposePhone;
        this.props.onChangeExpose(id, data);
    };

    onExposeEmailClick = (id, alias) => () => {
        let data = alias;
        data.exposeEmail = !data.exposeEmail;
        this.props.onChangeExpose(id, data);
    };

    onAddButtonClick = () => {
        this.setState({
            mode: ADD_MODE,
            currentAliasId: null
        });
        this.props.onOpenAddAliasModal();
    };

    onEditButtonClick = (id) => () => {
        this.setState({
            mode: EDIT_MODE,
            currentAliasId: id
        });
        this.props.onOpenAddAliasModal();
    };

    onRemoveButtonClick = (id) => () => {
        this.setState({ currentAliasId: id });
        this.props.onOpenRemoveAliasModal();
    };
}

AliasesList.propTypes = {
    data: PropTypes.array,
    loading: PropTypes.bool,
    translation: PropTypes.object.isRequired,
    onGetAliases: PropTypes.func.isRequired,
    onChangeExpose: PropTypes.func.isRequired,
    onSetDefaultAlias: PropTypes.func.isRequired,
    onOpenAddAliasModal: PropTypes.func.isRequired,
    onOpenRemoveAliasModal: PropTypes.func.isRequired
};

export default AliasesList;



// WEBPACK FOOTER //
// ./src/components/accountManagement/aliasesManagement/aliasesList/AliasesList.js